import Yup from 'src/infra/Yup';
import {PlatformIntl} from 'src/infra/PlatformIntl';

const intl = PlatformIntl.getInstance();

const baseSchema = Yup.object().shape({
  customerId: Yup.number().label(intl.formatMessage('sharedCompany')),
  label: Yup.string().label(intl.formatMessage('companyLabel')),
  customDomain: Yup.string().required().label(intl.formatMessage('companyCustomDomain')),
  hideLoginFooter: Yup.boolean().label(intl.formatMessage('companyHideLoginFooter')),
  theme: Yup.string().required().label(intl.formatMessage('companyTheme')),
  androidAppUrl: Yup.string().label(intl.formatMessage('companyAndroidAppUrl')),
  iosAppUrl: Yup.string().label(intl.formatMessage('companyIOSAppUrl')),
  customerAreaLink: Yup.string().label(intl.formatMessage('companyCustomerAreaLink')),
  customerAreaContact: Yup.string().label(intl.formatMessage('companyCustomerAreaContact')),
  assistanceService: Yup.boolean().label(intl.formatMessage('companyAssistanceService')),
  monitoringCenterService: Yup.boolean().label(intl.formatMessage('companyMonitoringCenterService')),
  monitoringCenterContact: Yup.string().label(intl.formatMessage('companyMonitoringCenterContact')),
});

const attachmentSchema = Yup.mixed<File>()
  .label(intl.formatMessage('companyLogo'))
  .test('is-file', intl.formatMessage('error_invalid_type'), (value) => {
    if (value === null || value === undefined) {
      return true;
    }
    return value instanceof File;
  });

export const createCompanySchema = baseSchema.clone().shape({
  attachment: attachmentSchema.clone(),
});

export const updateCompanySchema = baseSchema.clone().shape({
  id: Yup.number().required().label('ID'),
  attachment: attachmentSchema.clone(),
});
